/**
 * this service is private and meant to be used by UserMatchingMixin only!
 */

import UserMatchingService from '../../../../../utils/UserMatchingService';

// helper methods of service

// methods exported by service
const addUserMatchingFieldRules = function () {
	if (this.isUserMatching) {
		const fallbackRequired = UserMatchingService.validFallback(this.$data._paramFallback) || 'This field requires fallback';
		this.addFieldRule(fallbackRequired);
	}
};

const updateFallback = function (payload) {
	this.$data._paramFallback = payload;
	const keyFallback = { key: this.param.key, value: payload };
	this.$emit('update-input-fallback', keyFallback);
};

const UserMatchingMixinService = {
	addUserMatchingFieldRules,
	updateFallback,
};

export default UserMatchingMixinService;
